import { useState, useCallback } from "react";
import { toast } from "sonner";
import { adminApi } from "../../api";

/**
 * Detail modal state: open/close, view/edit modes, save.
 * `onSaved` is fired so the page can reload the list on successful edit.
 */
export default function useSummaryDetail({ onSaved } = {}) {
  const [detail, setDetail] = useState(null);
  const [editing, setEditing] = useState(false);
  const [editForm, setEditForm] = useState({ resumo: "", tag1: "", tag2: "", tag3: "" });
  const [saving, setSaving] = useState(false);

  const open = useCallback(async (id) => {
    try {
      const r = await adminApi.summaryGet(id);
      setDetail({ id, ...r });
      setEditing(false);
    } catch (e) {
      toast.error(e.message || "Erro ao abrir detalhe");
    }
  }, []);

  const close = useCallback(() => {
    setDetail(null);
    setEditing(false);
  }, []);

  const startEdit = useCallback(() => {
    if (!detail) return;
    setEditForm({
      resumo: detail.content?.resumo || "",
      tag1: detail.content?.tag1 || "",
      tag2: detail.content?.tag2 || "",
      tag3: detail.content?.tag3 || "",
    });
    setEditing(true);
  }, [detail]);

  const cancelEdit = useCallback(() => setEditing(false), []);

  const updateEditField = useCallback((field, value) => {
    const max = field === "resumo" ? 1000 : 100;
    setEditForm((s) => ({ ...s, [field]: value.slice(0, max) }));
  }, []);

  const save = useCallback(async () => {
    if (!detail) return;
    setSaving(true);
    try {
      await adminApi.summaryEdit(detail.id, {
        resumo: editForm.resumo.slice(0, 950),
        tag1: editForm.tag1.slice(0, 100),
        tag2: editForm.tag2.slice(0, 100),
        tag3: editForm.tag3.slice(0, 100),
      });
      toast.success("Resumo actualizado");
      const r = await adminApi.summaryGet(detail.id);
      setDetail({ id: detail.id, ...r });
      setEditing(false);
      onSaved?.();
    } catch (e) {
      toast.error(e.message || "Erro ao guardar");
    }
    setSaving(false);
  }, [detail, editForm, onSaved]);

  return {
    detail, setDetail, open, close,
    editing, editForm, updateEditField,
    startEdit, cancelEdit, saving, save,
  };
}
